import { AppState, picoapp } from "picoapp";
import * as components from "./components";
import * as pageComponents from "./pages";
import { Slider } from "../scripts/global";
import { initSection } from "../scripts/utils";
import { initPdpStickyLayout } from "./pages/pdp-sticky-layout";

const initialState: AppState = {
  products: {},
  dialogs: {},
};

const app = picoapp({ ...components, ...pageComponents }, initialState);

/**
 * Keen can fail internally (try/catch in library) without throwing; created() never runs and
 * slides stay at Liquid opacity:0. If no instance was attached after init, show content anyway.
 */
function ensureAnnouncementCarouselSlidesVisible() {
  document.querySelectorAll("slider-container.announcements-bar").forEach((node) => {
    const el = node as HTMLElement & { _keenSliderInstance?: unknown };
    if (el.dataset.disabled === "true" || el.dataset.singleSlide === "true") {
      return;
    }
    if (el._keenSliderInstance) {
      return;
    }
    el.querySelectorAll(".keen-slider__slide").forEach((slide) => {
      (slide as HTMLElement).style.opacity = "1";
    });
  });
}

function bootApp() {
  /* Keen sliders must init before picoapp mounts — promotionBanner (and others) prune/update slides;
   * double-mount or DOM changes before created() leave slides at opacity:0 from Liquid. */
  initSection("slider-container", Slider);
  initPdpStickyLayout();
  /* Mount after paint so Keen layout can settle; then recover any failed inits. */
  requestAnimationFrame(() => {
    app.mount();
    requestAnimationFrame(() => {
      ensureAnnouncementCarouselSlidesVisible();
    });
  });
}

/* Scripts in head may run after DOMContentLoaded if load order changes; still bootstrap. */
if (document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", bootApp);
} else {
  bootApp();
}

window.addEventListener("shopify:section:load", (event: Event) => {
  const root = event.target as HTMLElement | null;
  if (root?.querySelectorAll) {
    root.querySelectorAll("slider-container").forEach((el) => {
      const container = el as HTMLElement & {
        _keenSliderInstance?: unknown;
      };
      if (!container._keenSliderInstance) {
        try {
          new Slider(container);
        } catch (err) {
          console.error(
            "[shopify:section:load] Slider init failed:",
            container,
            err
          );
        }
      }
    });
  }
  initPdpStickyLayout();
  app.mount();
  requestAnimationFrame(() => {
    requestAnimationFrame(ensureAnnouncementCarouselSlidesVisible);
  });
});

window.addEventListener("picoapp:mount", () => {
  initPdpStickyLayout();
  app.mount();
});

export default app;
